/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.framework.folders.rpc.MoveObjectsRpc
 */

export const moveObjectsToAnotherFolderRpc = {
  serviceName: 'com.hubspot.framework.folders.rpc.MoveObjectsRpc',
  rpcName: 'moveObjectsToAnotherFolder',
  auth: 'app',
  fingerprint: 'CkrYbBlTrYUKajr86kmtiSfLQwjoSXFW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};